module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_nara-11954bd0f96f4cb2bb0e880bdf8419aa.jpg";